/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/ClientSide/javascript.js to edit this template
 */


import { useState, useEffect }
    from "react";
import { useParams, useLocation }
    from 'react-router-dom';

import { Container, Row, Col, Tab, Nav }
    from 'react-bootstrap';
import { library }
    from '@fortawesome/fontawesome-svg-core';
import { fas }
    from '@fortawesome/free-solid-svg-icons';
import { fab }
    from '@fortawesome/free-brands-svg-icons';
import { far }
    from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon }
    from '@fortawesome/react-fontawesome';

library.add(fas, fab, far);
function Payments() {

    return (
        <div>
            <Row><h2>Payment Details</h2></Row>
            <br />
            <Row>
                <p>
                    <b>How do I make a payment for my Grace Super Market purchase?</b><br />
                    We offer two payment options:<br />
                    • Cash on Delivery (C-O-D)<br />
                    • Card Payment (Debit/Credit card and Netbanking)<br />
                    <br />
                    <b>Are there any hidden charges or GST on my purchase?</b><br />
                    No, there are absolutely no hidden charges. All prices listed on our product pages are final and inclusive of all taxes, including GST. Additionally, we offer free delivery on orders of Rs. 1000 or more.<br />
                    <br />
                    <b>What is Cash on Delivery (C-O-D)?</b><br />
                    Cash on Delivery allows you to pay for your order in cash only when it is delivered to your doorstep. This is an alternative to online payments such as credit/debit cards or net banking, where you pay upfront.<br />
                    <br />
                    <b>What is the Card Payment option?</b><br />
                    You can pay for your purchases online using your Debit or Credit card, or via Netbanking during checkout. This method requires payment at the time of placing the order.<br />
                    <br />
                    <b>Are there any special terms for Cash on Delivery orders?</b><br />
                    Yes, please note the following for C-O-D payments:<br />
                    • Maximum order value allowed is Rs. 10,000.<br />
                    • Payment must be made in cash only.<br />
                    • We do not accept foreign currency for C-O-D orders.<br />
                    <br />
                    <b>How to place a Cash on Delivery (C-O-D) order?</b><br />
                    1. Select products marked with the "Cash-on-Delivery Available" icon and add them to your cart.<br />
                    2. Proceed to checkout and select the payment option “Pay By Cash-on-Delivery.”<br />
                    3. After your order is verified and confirmed, it will be processed and shipped within the specified timeframe.<br />
                    4. Please make the payment in cash directly to the delivery person when your order arrives.<br />
                    <br />
                    <b>Terms & Conditions for C-O-D</b><br />
                    • Maximum order value for C-O-D is Rs. 10,000.<br />
                    • Only cash payments are accepted at the time of delivery.<br />
                    <br />
                    <b>Contact Us</b><br />
                    If you have any questions or need further assistance, please don’t hesitate to contact us.<br />

                </p>
            </Row>
        </div>

    );
}

export default Payments;